import {
  AutoEnrollmentDefaultConditionsModel,
  AutoEnrollmentDocumentsModel,
  AutoEnrollmentModel,
  AutoEnrollmentRepository,
  AutoEnrollmentTypes,
} from '@/AutoEnrollment/domain'
import { Step1Form, Step2Form, Step3Form } from '@/AutoEnrollment/ui/hooks'
import { Step2Form as OwnerDataForm } from '@/Contract/ui/hooks'
import { LogaltyModel, LogaltyResponseStatus } from '@/Logalty/domain'
import { HttpModel } from '@/Shared/domain'

export interface IAutoEnrollment {
  getAutoEnrollmentData: () => Promise<HttpModel<AutoEnrollmentModel>>
  getAutoEnrollmentProductData: () => Promise<HttpModel<AutoEnrollmentModel>>
  checkCifAlreadyExists: (cif: string) => Promise<HttpModel<boolean>>
  getDefaultConditionsData: () => Promise<
    HttpModel<AutoEnrollmentDefaultConditionsModel[]>
  >
  getDocumentsData: (
    processType: AutoEnrollmentTypes,
  ) => Promise<HttpModel<AutoEnrollmentDocumentsModel>>
  getAutoEnrollmentLogaltyStatus: (
    processType: AutoEnrollmentTypes,
  ) => Promise<HttpModel<LogaltyResponseStatus>>
  saveAutoEnrollmentStep1: (data: Step1Form) => Promise<HttpModel<boolean>>
  saveAutoEnrollmentStep2: (data: Step2Form) => Promise<HttpModel<boolean>>
  saveAutoEnrollmentStep3: (data: Step3Form) => Promise<HttpModel<LogaltyModel>>
  updateOwnerData: (data: OwnerDataForm) => Promise<HttpModel<boolean>>
}

export const AutoEnrollmentContract = (
  autoEnrollmentRepository: AutoEnrollmentRepository,
): IAutoEnrollment => ({
  getAutoEnrollmentData: async (): Promise<HttpModel<AutoEnrollmentModel>> =>
    await autoEnrollmentRepository.GetAutoEnrollmentData(),
  getAutoEnrollmentProductData: async (): Promise<HttpModel<AutoEnrollmentModel>> =>
    await autoEnrollmentRepository.GetAutoEnrollmentProductData(),
  checkCifAlreadyExists: async (cif: string): Promise<HttpModel<boolean>> =>
    await autoEnrollmentRepository.CheckCifAlreadyExists(cif),
  getDefaultConditionsData: async (): Promise<
    HttpModel<AutoEnrollmentDefaultConditionsModel[]>
  > => await autoEnrollmentRepository.GetDefaultConditionsData(),
  getDocumentsData: async (
    processType: AutoEnrollmentTypes,
  ): Promise<HttpModel<AutoEnrollmentDocumentsModel>> =>
    await autoEnrollmentRepository.GetDocumentsData(processType),
  getAutoEnrollmentLogaltyStatus: async (
    processType: AutoEnrollmentTypes,
  ): Promise<HttpModel<LogaltyResponseStatus>> =>
    await autoEnrollmentRepository.GetAutoEnrollmentLogaltyStatus(processType),
  saveAutoEnrollmentStep1: async (data: Step1Form): Promise<HttpModel<boolean>> =>
    await autoEnrollmentRepository.SaveAutoEnrollmentStep1(data),
  saveAutoEnrollmentStep2: async (data: Step2Form): Promise<HttpModel<boolean>> =>
    await autoEnrollmentRepository.SaveAutoEnrollmentStep2(data),
  saveAutoEnrollmentStep3: async (data: Step3Form): Promise<HttpModel<LogaltyModel>> =>
    await autoEnrollmentRepository.SaveAutoEnrollmentStep3(data),
  updateOwnerData: async (data: OwnerDataForm): Promise<HttpModel<boolean>> =>
    await autoEnrollmentRepository.UpdateOwnerData(data),
})
